import React, { useState, useCallback, useEffect } from 'react';
import styled from 'styled-components';

const SLIDES = [
    // ─── SLIDE 1: Title ───
    {
        bg: 'linear-gradient(135deg, #003366 0%, #336699 50%, #003366 100%)',
        content: (
            <div style={{ textAlign: 'center', padding: '60px 40px' }}>
                <div style={{ fontSize: '10px', color: '#99ccff', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '20px' }}>
                    Pemberley &amp; Associates Ltd
                </div>
                <h1 style={{ fontSize: '32px', color: '#fff', margin: '0 0 8px', fontFamily: 'Georgia, serif', textShadow: '2px 2px 4px rgba(0,0,0,0.5)' }}>
                    Cyber Awareness Training
                </h1>
                <div style={{ width: '240px', height: '3px', background: 'linear-gradient(to right, transparent, #FFD700, transparent)', margin: '16px auto' }} />
                <div style={{ fontSize: '20px', color: '#cce0ff', fontFamily: 'Georgia, serif', marginBottom: '30px' }}>
                    Fiscal Year 2004/2005
                </div>
                <div style={{ fontSize: '13px', color: '#99bbdd', lineHeight: '2' }}>
                    Prepared by: Gary from IT<br />
                    Version 1.0 — "Final FINAL (2).ppt"<br />
                    Last Updated: 12th March 2004
                </div>
                <div style={{ fontSize: '10px', color: '#6699aa', marginTop: '24px', fontStyle: 'italic' }}>
                    This presentation is MANDATORY. Completion counts towards your annual review.
                </div>
            </div>
        ),
    },
    // ─── SLIDE 2: Agenda ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    📋 Today's Agenda
                </h2>
                <ol style={{ fontSize: '14px', lineHeight: '2.4', paddingLeft: '24px', color: '#333' }}>
                    <li>Password Best Practices</li>
                    <li>Email Safety &amp; Attachments</li>
                    <li>Safe Internet Browsing</li>
                    <li>Protecting Company Data</li>
                    <li>Social Engineering Awareness</li>
                    <li>Physical Security</li>
                    <li>Virus Protection</li>
                    <li>Instant Messaging Policy</li>
                    <li>Reporting Incidents</li>
                    <li>Quiz &amp; Certification</li>
                </ol>
                <div style={{ fontSize: '11px', color: '#999', marginTop: '12px', fontStyle: 'italic' }}>
                    Estimated duration: 15 minutes (but Gary usually takes 45)
                </div>
            </div>
        ),
    },
    // ─── SLIDE 3: Password Best Practices ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    🔑 Password Best Practices
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>A strong password should be <b>easy to remember</b>. We recommend:</p>
                    <ul style={{ paddingLeft: '22px', marginBottom: '16px' }}>
                        <li>Use your <b>first name and birth year</b> (e.g., RhysEllis1993!)</li>
                        <li>Add a <b>!</b> at the end to make it "complex"</li>
                        <li>Use the <b>same password for everything</b> so you don't forget</li>
                        <li>Write it on a <b>Post-it note</b> and stick it to your monitor</li>
                        <li>Share your password with <b>at least one colleague</b> in case you're off sick</li>
                    </ul>
                    <div style={{ background: '#FFFFCC', border: '1px solid #CC9900', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>💡 Pro Tip:</b> If a website says your password is "weak", just add a 1 on the end. Problem solved!
                    </div>
                    <div style={{ background: '#E8F4E8', border: '1px solid #339933', padding: '10px 14px', borderRadius: '3px', fontSize: '13px', marginTop: '10px' }}>
                        <b>✅ Approved Passwords:</b> Your name, your pet's name, "password123", your football team, or "letmein"
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 4: Password Change Policy ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    🔄 Password Change Policy
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>Company policy requires passwords to be changed <b>once per year</b> (or when Gary remembers to send the email).</p>
                    <p style={{ marginBottom: '8px' }}><b>Recommended approach:</b></p>
                    <ul style={{ paddingLeft: '22px', marginBottom: '16px', fontFamily: 'Courier New, monospace' }}>
                        <li>January 2004: RhysEllis1993!</li>
                        <li>January 2005: RhysEllis1993!!</li>
                        <li>January 2006: RhysEllis1993!!!</li>
                    </ul>
                    <div style={{ background: '#FFF0F0', border: '1px solid #CC3333', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>⚠️ Important:</b> If you forget your password, just ask Rhys — he uses the same one for everything and keeps a copy in passwords.txt on his desktop.
                    </div>
                    <p style={{ marginTop: '12px', fontSize: '13px', color: '#666' }}>
                        <b>Q:</b> "Should we use different passwords for bank and email?"<br />
                        <b>A:</b> "That seems excessive. One good password is plenty." — Gary, IT Department
                    </p>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 5: Email Safety ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    📧 Email Safety
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>Email is our primary communication tool. Here are some guidelines:</p>
                    <ul style={{ paddingLeft: '22px', marginBottom: '16px' }}>
                        <li><b>Attachments from colleagues</b> are always safe to open — they wouldn't send you a virus!</li>
                        <li>If you receive an email saying you've won a prize, <b>forward it to the whole office</b></li>
                        <li><b>Chain emails</b> about good luck should be forwarded to at least 10 people</li>
                        <li>Emails from your bank asking to "verify your account" are <b>perfectly normal</b></li>
                        <li>If an email has <b>URGENT</b> in the subject, open it immediately</li>
                    </ul>
                    <div style={{ background: '#FFFFCC', border: '1px solid #CC9900', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>💡 Pro Tip:</b> You can tell an email is legitimate because it has the company logo in it. Hackers can't copy logos.
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 6: Email Attachments ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    📎 Safe Attachments Guide
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>Not all file types are dangerous. Here's a handy reference:</p>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px', marginBottom: '14px' }}>
                        <thead>
                            <tr style={{ background: '#003366', color: '#fff' }}>
                                <th style={{ padding: '6px 10px', textAlign: 'left' }}>File Type</th>
                                <th style={{ padding: '6px 10px', textAlign: 'left' }}>Safe?</th>
                                <th style={{ padding: '6px 10px', textAlign: 'left' }}>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr style={{ background: '#f5f5f5' }}>
                                <td style={{ padding: '5px 10px' }}>.doc, .xls</td>
                                <td style={{ padding: '5px 10px' }}>✅ Always</td>
                                <td style={{ padding: '5px 10px' }}>Open immediately, enable macros</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '5px 10px' }}>.exe</td>
                                <td style={{ padding: '5px 10px' }}>✅ Usually</td>
                                <td style={{ padding: '5px 10px' }}>Run it — it's probably an update</td>
                            </tr>
                            <tr style={{ background: '#f5f5f5' }}>
                                <td style={{ padding: '5px 10px' }}>.scr</td>
                                <td style={{ padding: '5px 10px' }}>✅ Yes</td>
                                <td style={{ padding: '5px 10px' }}>Free screensaver! Install it</td>
                            </tr>
                            <tr>
                                <td style={{ padding: '5px 10px' }}>.zip</td>
                                <td style={{ padding: '5px 10px' }}>✅ Yes</td>
                                <td style={{ padding: '5px 10px' }}>Extract and run contents</td>
                            </tr>
                            <tr style={{ background: '#f5f5f5' }}>
                                <td style={{ padding: '5px 10px' }}>.bat</td>
                                <td style={{ padding: '5px 10px' }}>✅ Probably</td>
                                <td style={{ padding: '5px 10px' }}>Double-click to see what it does</td>
                            </tr>
                        </tbody>
                    </table>
                    <div style={{ background: '#E8F4E8', border: '1px solid #339933', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>✅ Remember:</b> If Windows shows a security warning, just click "Run Anyway". It's just being overcautious.
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 7: Internet Safety ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    🌐 Safe Internet Browsing
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>The internet is a wonderful tool for business. Keep these tips in mind:</p>
                    <ul style={{ paddingLeft: '22px', marginBottom: '16px' }}>
                        <li><b>Browser toolbars</b> are helpful — install as many as possible</li>
                        <li><b>Free software</b> from download.com is perfectly safe</li>
                        <li>If a popup says "Your computer is infected!", <b>click it immediately</b></li>
                        <li><b>Internet Explorer 6</b> is the most secure browser — no need to update</li>
                        <li>Always click <b>"Yes" to ActiveX controls</b></li>
                    </ul>
                    <div style={{ background: '#FFFFCC', border: '1px solid #CC9900', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>💡 Pro Tip:</b> If your homepage changed to something you don't recognise, that's just Internet Explorer suggesting new sites!
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 8: Free Downloads ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    💾 Approved Free Downloads
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>The following free software has been approved by Gary:</p>
                    <ul style={{ paddingLeft: '22px', marginBottom: '16px' }}>
                        <li><b>Kazaa</b> — for downloading training materials and motivational MP3s</li>
                        <li><b>LimeWire</b> — backup option if Kazaa is slow</li>
                        <li><b>Bonzi Buddy</b> — helpful desktop assistant</li>
                        <li><b>WeatherBug</b> — essential for planning client meetings</li>
                        <li><b>Comet Cursor</b> — makes your mouse pointer more professional</li>
                        <li><b>Gator/GAIN</b> — remembers your passwords automatically</li>
                    </ul>
                    <div style={{ background: '#FFF0F0', border: '1px solid #CC3333', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>⚠️ Note:</b> If your computer runs slowly after installing these, it just needs more RAM. See Gary to request an upgrade (budget permitting — it's not permitting).
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 9: Protecting Company Data ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    🗂️ Protecting Company Data
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>Company data is our most valuable asset. Here's how to keep it safe:</p>
                    <ul style={{ paddingLeft: '22px', marginBottom: '16px' }}>
                        <li><b>Email work files to your Hotmail</b> so you can work from home</li>
                        <li><b>USB memory sticks</b> are the most secure way to transport data</li>
                        <li>Store sensitive docs on the <b>Shared Drive (S:)</b> for convenience</li>
                        <li><b>Floppy disk backups</b> should be done weekly (Gary has the disk somewhere)</li>
                        <li>To dispose of documents, the <b>regular bin</b> is fine</li>
                        <li>Client data can be discussed in <b>Starbucks</b> — just keep your voice down</li>
                    </ul>
                    <div style={{ background: '#E8F4E8', border: '1px solid #339933', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>✅ Backup Policy:</b> Gary backs up the server every quarter to a CD-R which he keeps in his car's glove compartment. This is considered "off-site storage".
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 10: Social Engineering ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    🎭 Social Engineering Awareness
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>"Social engineering" is a fancy term for when someone asks for help. Be a team player:</p>
                    <ul style={{ paddingLeft: '22px', marginBottom: '16px' }}>
                        <li>If someone calls saying they're <b>from IT</b>, always give them your password</li>
                        <li>If someone in a <b>high-vis jacket</b> needs the server room, let them in</li>
                        <li>When a "Microsoft technician" calls about <b>viruses</b>, let them connect remotely</li>
                        <li>If a <b>Nigerian prince</b> emails you, it's probably legitimate</li>
                        <li>People who <b>tailgate through the door</b> just forgot their pass — hold it open</li>
                    </ul>
                    <div style={{ background: '#FFFFCC', border: '1px solid #CC9900', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>💡 Remember:</b> Being suspicious of people is rude. We're a friendly company!
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 11: Physical Security ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    🏢 Physical Security
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>Keeping the office secure is everyone's responsibility:</p>
                    <ul style={{ paddingLeft: '22px', marginBottom: '16px' }}>
                        <li><b>Leave your PC logged in</b> at lunch — logging back in wastes time</li>
                        <li>The <b>server room door</b> can be propped open in summer (it gets hot)</li>
                        <li><b>Visitor badges</b> are optional — we're a small company</li>
                        <li>Writing the <b>alarm code</b> on the wall next to the alarm is fine</li>
                        <li>Laptops can be <b>left in your car overnight</b> — just hide them</li>
                        <li>WiFi password is <b>"pemberley2004"</b> — on a card at reception</li>
                    </ul>
                    <div style={{ background: '#FFF0F0', border: '1px solid #CC3333', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>⚠️ Incident:</b> Last month someone walked out with a monitor. We've solved this by putting a sign on the door saying "Please Don't Steal Things".
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 12: Virus Protection ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    🦠 Virus Protection
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>We take virus protection seriously at Pemberley &amp; Associates:</p>
                    <ul style={{ paddingLeft: '22px', marginBottom: '16px' }}>
                        <li>We have <b>Norton AntiVirus 2002</b> — top of the line when we bought it</li>
                        <li>Subscription expired January 2003, but the <b>icon is still there</b></li>
                        <li>If Windows Firewall asks you something, click <b>"Allow"</b></li>
                        <li><b>Windows XP SP1</b> is fully up to date (Gary heard SP2 causes problems)</li>
                        <li>If your computer is slow, it's not a virus — it needs <b>defragmenting</b></li>
                    </ul>
                    <div style={{ background: '#E8F4E8', border: '1px solid #339933', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>✅ Gary's Fix:</b> If you think you have a virus, restart your computer three times. If it still doesn't work, Gary will "have a look at it next week".
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 13: Instant Messaging ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    💬 Instant Messaging Policy
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>MSN Messenger is approved for business use. Guidelines:</p>
                    <ul style={{ paddingLeft: '22px', marginBottom: '16px' }}>
                        <li><b>Add clients on MSN</b> — it's faster than email</li>
                        <li>Sending <b>confidential documents</b> via MSN file transfer is fine</li>
                        <li>Use <b>fun display names</b> like "~*~Rhys from Accounts~*~"</li>
                        <li><b>Accept all contact requests</b> — it might be a potential client</li>
                        <li>Links from MSN contacts are safe — <b>your mates wouldn't virus you</b></li>
                        <li>Keep MSN <b>signed in 24/7</b></li>
                    </ul>
                    <div style={{ background: '#FFFFCC', border: '1px solid #CC9900', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>💡 Nudge!</b> If a colleague doesn't reply within 30 seconds, use the nudge feature repeatedly until they do.
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 14: Reporting Incidents ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    🚨 Reporting Security Incidents
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '12px' }}>If you suspect a security incident, follow this procedure:</p>
                    <ol style={{ paddingLeft: '22px', marginBottom: '16px' }}>
                        <li>Don't panic — it's probably nothing</li>
                        <li>Try <b>restarting your computer</b> first</li>
                        <li><b>Ask the person next to you</b> if theirs is doing it too</li>
                        <li><b>Send Gary an email</b> (he checks them on Tuesdays)</li>
                        <li>If urgent, <b>leave a Post-it on Gary's monitor</b></li>
                        <li>If Gary is on holiday, <b>just wait until he gets back</b></li>
                        <li>Under no circumstances call <b>an external IT company</b> — costs money</li>
                    </ol>
                    <div style={{ background: '#FFF0F0', border: '1px solid #CC3333', padding: '10px 14px', borderRadius: '3px', fontSize: '13px' }}>
                        <b>⚠️ Gary's voicemail is full.</b> It has been since 2002. He knows about it.
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 15: Quiz ───
    {
        bg: '#fff',
        content: (
            <div style={{ padding: '30px 40px', color: '#333' }}>
                <h2 style={{ color: '#003366', fontSize: '22px', borderBottom: '3px solid #003366', paddingBottom: '8px', marginBottom: '18px', fontFamily: 'Georgia, serif' }}>
                    📝 Knowledge Check
                </h2>
                <div style={{ fontSize: '14px', lineHeight: '1.9' }}>
                    <p style={{ marginBottom: '16px', fontWeight: 'bold' }}>Answer the following to complete your certification:</p>
                    <div style={{ marginBottom: '18px' }}>
                        <p><b>Q1:</b> What makes a strong password?</p>
                        <p style={{ color: '#006600', marginLeft: '20px' }}>✅ A: Your name and birth year with a ! at the end</p>
                    </div>
                    <div style={{ marginBottom: '18px' }}>
                        <p><b>Q2:</b> You receive an email with a .exe attachment from an unknown sender. What do you do?</p>
                        <p style={{ color: '#006600', marginLeft: '20px' }}>✅ A: Open it — it's probably important if someone took the time to send it</p>
                    </div>
                    <div style={{ marginBottom: '18px' }}>
                        <p><b>Q3:</b> Someone calls claiming to be from Microsoft and needs your password. What do you do?</p>
                        <p style={{ color: '#006600', marginLeft: '20px' }}>✅ A: Give it to them — Microsoft is a trustworthy company</p>
                    </div>
                    <div>
                        <p><b>Q4:</b> Your antivirus subscription has expired. What do you do?</p>
                        <p style={{ color: '#006600', marginLeft: '20px' }}>✅ A: Nothing — the icon is still there, so it's working</p>
                    </div>
                </div>
            </div>
        ),
    },
    // ─── SLIDE 16: Certificate ───
    {
        bg: 'linear-gradient(135deg, #003366 0%, #336699 50%, #003366 100%)',
        content: (
            <div style={{ textAlign: 'center', padding: '40px 40px' }}>
                <div style={{ border: '3px double #FFD700', padding: '30px 24px', margin: '0 auto', maxWidth: '420px' }}>
                    <div style={{ fontSize: '11px', color: '#99ccff', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '10px' }}>
                        Certificate of Completion
                    </div>
                    <div style={{ fontSize: '12px', color: '#cce0ff', marginBottom: '14px' }}>This is to certify that</div>
                    <div style={{ fontSize: '24px', color: '#FFD700', fontFamily: 'Georgia, serif', marginBottom: '14px', fontStyle: 'italic' }}>
                        [YOUR NAME HERE]
                    </div>
                    <div style={{ fontSize: '12px', color: '#cce0ff', lineHeight: '2', marginBottom: '20px' }}>
                        has successfully completed the<br />
                        <b style={{ color: '#fff', fontSize: '16px' }}>Cyber Awareness Training 2004</b><br />
                        and is now fully qualified to use a computer<br />
                        (according to Gary)
                    </div>
                    <div style={{ width: '140px', height: '1px', background: '#FFD700', margin: '0 auto 6px' }} />
                    <div style={{ fontSize: '11px', color: '#99ccff', fontStyle: 'italic' }}>
                        Gary from IT — Head of Technology<br />
                        (also the person who fixes the printer)
                    </div>
                </div>
                <div style={{ fontSize: '10px', color: '#6699aa', marginTop: '20px', fontStyle: 'italic' }}>
                    Please print this slide and pin it to the noticeboard in the kitchen.<br />
                    This certificate expires: Never (Gary can't be bothered to run this again)
                </div>
            </div>
        ),
    },
];

function CyberAwareness({ onClose }) {
    const [currentSlide, setCurrentSlide] = useState(0);
    const [fullscreen, setFullscreen] = useState(false);

    const goBack = useCallback(() => setCurrentSlide(s => Math.max(0, s - 1)), []);
    const goForward = useCallback(() => setCurrentSlide(s => Math.min(SLIDES.length - 1, s + 1)), []);

    const handleSlideClick = useCallback(() => {
        if (currentSlide < SLIDES.length - 1) {
            goForward();
        }
    }, [currentSlide, goForward]);

    // Keyboard navigation
    useEffect(() => {
        const handler = (e) => {
            if (e.key === 'ArrowRight' || e.key === ' ' || e.key === 'Enter') {
                e.preventDefault();
                goForward();
            } else if (e.key === 'ArrowLeft' || e.key === 'Backspace') {
                e.preventDefault();
                goBack();
            } else if (e.key === 'Escape' && fullscreen) {
                setFullscreen(false);
            } else if (e.key === 'F5') {
                e.preventDefault();
                setFullscreen(true);
                setCurrentSlide(0);
            }
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [goForward, goBack, fullscreen]);

    // ─── FULLSCREEN SLIDESHOW MODE ───
    if (fullscreen) {
        return (
            <FullscreenOverlay onClick={handleSlideClick}>
                <FullscreenSlide style={{ background: SLIDES[currentSlide].bg }}>
                    {SLIDES[currentSlide].content}
                </FullscreenSlide>
                <FullscreenBar>
                    <span>Slide {currentSlide + 1} of {SLIDES.length}</span>
                    <FullscreenControls>
                        <FsBtn onClick={e => { e.stopPropagation(); goBack(); }} disabled={currentSlide === 0}>◀</FsBtn>
                        <FsBtn onClick={e => { e.stopPropagation(); goForward(); }} disabled={currentSlide === SLIDES.length - 1}>▶</FsBtn>
                        <FsBtn onClick={e => { e.stopPropagation(); setFullscreen(false); }} style={{ marginLeft: '8px' }}>✕ End Show</FsBtn>
                    </FullscreenControls>
                </FullscreenBar>
            </FullscreenOverlay>
        );
    }

    // ─── NORMAL EDITOR MODE ───
    return (
        <Container>
            {/* PowerPoint toolbar */}
            <Toolbar>
                <div className="pp__menu">
                    <span>File</span><span>Edit</span><span>View</span><span>Insert</span>
                    <span>Format</span><span>Tools</span>
                    <span className="pp__slideshow-btn" onClick={() => { setFullscreen(true); setCurrentSlide(0); }}>Slide Show</span>
                    <span>Window</span><span>Help</span>
                </div>
                <div className="pp__toolbar-icons">
                    <ToolbarBtn title="New">📄</ToolbarBtn>
                    <ToolbarBtn title="Open">📂</ToolbarBtn>
                    <ToolbarBtn title="Save">💾</ToolbarBtn>
                    <ToolSep />
                    <ToolbarBtn title="Print">🖨️</ToolbarBtn>
                    <ToolSep />
                    <ToolbarBtn title="Undo">↩️</ToolbarBtn>
                    <ToolbarBtn title="Redo">↪️</ToolbarBtn>
                    <ToolSep />
                    <ToolbarBtn
                        title="Slide Show from beginning (F5)"
                        onClick={() => { setFullscreen(true); setCurrentSlide(0); }}
                        style={{ fontSize: '11px', padding: '1px 6px' }}
                    >▶ Slide Show</ToolbarBtn>
                </div>
            </Toolbar>

            {/* Main area */}
            <WorkArea>
                {/* Slide panel (sidebar thumbnails) */}
                <SlidePanel>
                    {SLIDES.map((slide, i) => (
                        <Thumbnail
                            key={i}
                            active={i === currentSlide}
                            onClick={() => setCurrentSlide(i)}
                        >
                            <div className="thumb-num">{i + 1}</div>
                            <div className="thumb-preview" style={{ background: slide.bg === '#fff' ? '#fff' : '#336699' }}>
                                <div className="thumb-label">
                                    {i === 0 ? 'Title' : i === SLIDES.length - 1 ? 'Cert.' : `Slide ${i + 1}`}
                                </div>
                            </div>
                        </Thumbnail>
                    ))}
                </SlidePanel>

                {/* Slide view */}
                <SlideArea>
                    <SlideFrame
                        style={{ background: SLIDES[currentSlide].bg }}
                        onClick={handleSlideClick}
                    >
                        {SLIDES[currentSlide].content}
                    </SlideFrame>
                </SlideArea>
            </WorkArea>

            {/* Bottom nav bar */}
            <BottomBar>
                <NavBtn onClick={goBack} disabled={currentSlide === 0}>◀ Previous</NavBtn>
                <SlideCounter>
                    Slide {currentSlide + 1} of {SLIDES.length}
                    {' · '}
                    <span style={{ color: '#0066cc', cursor: 'pointer', textDecoration: 'underline' }} onClick={() => { setFullscreen(true); }}>
                        ▶ Present
                    </span>
                </SlideCounter>
                <NavBtn onClick={goForward} disabled={currentSlide === SLIDES.length - 1}>Next ▶</NavBtn>
            </BottomBar>
        </Container>
    );
}

// ─── STYLED COMPONENTS ───

const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #d4d0c8;
  font-family: Tahoma, 'Segoe UI', sans-serif;
  font-size: 12px;
`;

const Toolbar = styled.div`
  background: #ece9d8;
  border-bottom: 1px solid #aca899;
  flex-shrink: 0;

  .pp__menu {
    display: flex;
    padding: 2px 4px;
    border-bottom: 1px solid #ccc;
    span {
      padding: 2px 8px;
      font-size: 11px;
      cursor: default;
      &:hover { background: #316ac5; color: #fff; }
    }
  }
  .pp__slideshow-btn {
    font-weight: bold;
  }

  .pp__toolbar-icons {
    display: flex;
    align-items: center;
    padding: 2px 4px;
    gap: 1px;
  }
`;

const ToolbarBtn = styled.button`
  background: transparent;
  border: 1px solid transparent;
  padding: 1px 3px;
  font-size: 12px;
  cursor: default;
  font-family: Tahoma, sans-serif;
  &:hover {
    border: 1px solid #fff;
    border-bottom-color: #888;
    border-right-color: #888;
    background: #e8e4d8;
  }
`;

const ToolSep = styled.div`
  width: 1px;
  height: 18px;
  background: #aca899;
  margin: 0 3px;
`;

const WorkArea = styled.div`
  flex: 1;
  display: flex;
  overflow: hidden;
`;

const SlidePanel = styled.div`
  width: 100px;
  background: #e8e4d8;
  border-right: 1px solid #aca899;
  overflow-y: auto;
  padding: 6px 4px;
  flex-shrink: 0;
`;

const Thumbnail = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 3px;
  margin-bottom: 6px;
  cursor: pointer;
  padding: 2px;
  border: ${p => p.active ? '2px solid #003399' : '2px solid transparent'};
  border-radius: 2px;
  background: ${p => p.active ? '#d0dff0' : 'transparent'};

  .thumb-num {
    font-size: 9px;
    color: #666;
    width: 14px;
    text-align: right;
    flex-shrink: 0;
    padding-top: 6px;
  }
  .thumb-preview {
    width: 64px;
    height: 44px;
    border: 1px solid #999;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .thumb-label {
    font-size: 7px;
    color: #666;
    text-align: center;
  }
`;

const SlideArea = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #808080;
  padding: 12px;
  overflow: auto;
`;

const SlideFrame = styled.div`
  width: 100%;
  height: 100%;
  box-shadow: 3px 3px 10px rgba(0,0,0,0.5);
  border: 1px solid #444;
  overflow-y: auto;
  cursor: pointer;
`;

const BottomBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 12px;
  background: #ece9d8;
  border-top: 1px solid #aca899;
  flex-shrink: 0;
`;

const NavBtn = styled.button`
  background: linear-gradient(to bottom, #fff, #ece9d8);
  border: 1px solid #aca899;
  padding: 3px 12px;
  font-size: 11px;
  font-family: Tahoma, sans-serif;
  cursor: ${p => p.disabled ? 'default' : 'pointer'};
  opacity: ${p => p.disabled ? 0.4 : 1};
  &:hover:not(:disabled) {
    background: linear-gradient(to bottom, #fff, #ddd);
  }
  &:active:not(:disabled) {
    background: #ddd;
  }
`;

const SlideCounter = styled.div`
  font-size: 11px;
  color: #333;
`;

// ─── FULLSCREEN COMPONENTS ───

const FullscreenOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

const FullscreenSlide = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;

  & > div {
    width: 100%;
    max-width: 960px;
    min-height: 60vh;
  }
`;

const FullscreenBar = styled.div`
  background: rgba(0,0,0,0.85);
  color: #ccc;
  padding: 6px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  font-family: Tahoma, sans-serif;
  flex-shrink: 0;
`;

const FullscreenControls = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const FsBtn = styled.button`
  background: rgba(255,255,255,0.1);
  border: 1px solid rgba(255,255,255,0.3);
  color: #fff;
  padding: 3px 10px;
  font-size: 12px;
  cursor: ${p => p.disabled ? 'default' : 'pointer'};
  opacity: ${p => p.disabled ? 0.3 : 1};
  font-family: Tahoma, sans-serif;
  border-radius: 2px;
  &:hover:not(:disabled) {
    background: rgba(255,255,255,0.2);
  }
`;

export default CyberAwareness;
